import { render, staticRenderFns } from "./SortenInput.vue?vue&type=template&id=32b2df88&"
import script from "./SortenInput.vue?vue&type=script&lang=js&"
export * from "./SortenInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports